module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr.e586c3dadc8dcd90.svg";